import {Component} from 'react';
import AddCardModal from "../modals/AddCardModal";
import ReactTable from "react-table";
import "react-table/react-table.css";
import React from "react";
import DeleteCardConfirmModal from "../modals/DeleteCardConfirmModal";
import FastCreditModal from "../modals/FastCreditModal";
import Badge from 'react-bootstrap/lib/Badge';
import Button from 'react-bootstrap/lib/Button';
import CardSub from "../subcomponents/CardSub";
import AzureTable from "../AzureTable";
import request from "request-promise-native";
import LoadingModal from "../modals/LoadingModal";
import DeleteDialog from "../../utils/modals/higher/DeleteDialog";
import FailedDialog from "../../utils/modals/FailedDialog";
import FormDialog from "../../utils/modals/FormDialog";
import {Alert, Row} from "react-bootstrap";
import Col from "react-bootstrap/lib/Col";
import Form from "react-bootstrap/lib/Form";
import ValidatedFormComponent from "../ValidatedFormComponent";

const GET_RECIPE_ENDPOINT = "https://qibipay.azurewebsites.net/api/RecipeGet";
const REMOVE_RECIPE_ENDPOINT = "https://qibipay.azurewebsites.net/api/RecipeRemove";
const ADD_RECIPE_ENDPOINT = "https://qibipay.azurewebsites.net/api/RecipeAdd";
const EDIT_RECIPE_ENDPOINT = "https://qibipay.azurewebsites.net/api/RecipeEdit";

const outputs = [
    {
        name: "Barionet Relay 1",
        value: "rel1"
    },
    {
        name: "Barionet Relay 2",
        value: "rel2"
    },
    {
        name: "Barionet Relay 3",
        value: "rel3"
    },
    {
        name: "Barionet Relay 4",
        value: "rel4"
    },
    {
        name: "Barionet Output 1",
        value: "out1"
    },
    {
        name: "Barionet Output 2",
        value: "out2"
    },
    {
        name: "Barionet Output 3",
        value: "out3"
    },
    {
        name: "Barionet Output 4",
        value: "out4"
    },
    {
        name: "Vemio Low Drive Output 1",
        value: 1
    },
    {
        name: "Vemio Low Drive Output 2",
        value: 2
    },
    {
        name: "Vemio Low Drive Output 3",
        value: 3
    },
    {
        name: "Vemio Low Drive Output 4",
        value: 4
    },
    {
        name: "Vemio Low Drive Output 5",
        value: 5
    },
    {
        name: "Vemio Low Drive Output 6",
        value: 6
    },
    {
        name: "Vemio Low Drive Output 7",
        value: 7
    },
    {
        name: "Vemio Low Drive Output 8",
        value: 8
    },
    {
        name: "Vemio Low Drive Output 9",
        value: 9
    },
    {
        name: "Vemio Low Drive Output 10",
        value: 10
    },
    {
        name: "Vemio Low Drive Output 11",
        value: 11
    },
    {
        name: "Vemio Low Drive Output 12",
        value: 12
    },
    {
        name: "Vemio High Drive Output 1",
        value: 25
    },
    {
        name: "Vemio High Drive Output 2",
        value: 26
    },
    {
        name: "Vemio High Drive Output 3",
        value: 27
    },
    {
        name: "Vemio High Drive Output 4",
        value: 28
    },
    {
        name: "Vemio High Drive Output 5",
        value: 29
    },
    {
        name: "Vemio High Drive Output 6",
        value: 30
    },
    {
        name: "Vemio High Drive Output 7",
        value: 31
    },
    {
        name: "Vemio High Drive Output 8",
        value: 32
    }
];

const inputs = [
    {
        name: "Barionet Input 1",
        value: "in1"
    },
    {
        name: "Barionet Input 2",
        value: "in2"
    },
    {
        name: "Barionet Input 3",
        value: "in3"
    },
    {
        name: "Barionet Input 4",
        value: "in4"
    },
    {
        name: "Barionet Input 5",
        value: "in5"
    },
    {
        name: "Barionet Input 6",
        value: "in6"
    },
    {
        name: "Barionet Input 7",
        value: "in7"
    },
    {
        name: "Barionet Input 8",
        value: "in8"
    },
    {
        name: "Vemio Input 1",
        value: 1
    },
    {
        name: "Vemio Input 2",
        value: 2
    },
    {
        name: "Vemio Input 3",
        value: 3
    },
    {
        name: "Vemio Input 4",
        value: 4
    },
    {
        name: "Vemio Input 5",
        value: 5
    },
    {
        name: "Vemio Input 6",
        value: 6
    },
    {
        name: "Vemio Input 7",
        value: 7
    },
    {
        name: "Vemio Input 8",
        value: 8
    },
];

class RecipeScreen extends Component {
    constructor(props) {
        /*
            Props:
             - access_code
             - logout
             - recipeId
             - onClose
        */
        super(props);

        this.state = {
            saveOpened: false,
            savingLoading: false,
            savingErr: null,

            recipes: null,
            recipeData: null,
            loadingErr: null,

            addProduct: null,

            loading: true
        };

        if(props.recipeId==null) {
            this.state.recipes = {
                products: []
            };
            this.state.loading = false;
            return;
        }

        this.getRecipeData();

    }

    async uploadRecipeData(name, description) {

        this.setState({
            savingLoading: true
        });

        const options = {
            method: 'POST',
            uri: this.props.recipeId==null ? ADD_RECIPE_ENDPOINT : EDIT_RECIPE_ENDPOINT,
            body: {
                access_code: this.props.access_code,
                recipeId: this.props.recipeId,
                products: this.state.recipes.products,
                name,
                description
            },
            json: true,
            resolveWithFullResponse: true,
            simple: false
        };

        const response = await request(options);

        this.setState({
            savingLoading: false
        });

        console.log("Response: ",response);

        if(response.statusCode===404) {
            this.props.logout();
            return;
        }

        if(response.statusCode===400) {
            this.setState({
                savingErr: response.body.msg
            });
            return;
        }

        if(response.statusCode!==200) {
            this.setState({
                savingErr: 'Server error occured, please retry later!'
            });
            return;
        }

        //Success
        this.props.onClose();
    }

    async getRecipeData() {
        const options = {
            method: 'POST',
            uri: GET_RECIPE_ENDPOINT,
            body: {

                access_code: this.props.access_code,
                recipeId: this.props.recipeId
            },
            json: true,
            resolveWithFullResponse: true,
            simple: false
        };

        const response = await request(options);

        this.setState({
            loading: false
        });

        console.log("Response: ",response);

        if(response.statusCode===404) {
            this.props.logout();
            return;
        }

        if(response.statusCode===400) {
            this.setState({
                loadingErr: response.body
            });
            return;
        }

        if(response.statusCode!==200) {
            this.setState({
                loadingErr: 'Server error occured, please retry later!'
            });
            return;
        }

        this.setState({
            recipes: response.body
        });
    }

    close() {
        //TODO: Check if something changed and ask the user
        this.props.onClose();
    }

    addProduct(name, id, price, recipe) {
        const toAdd = {};
        const objCpy = {...this.state.recipes};
        toAdd.name = name;
        toAdd.id = id;
        toAdd.price = price;
        toAdd.recipe = recipe;
        console.log("Submitted ",toAdd);
        if(objCpy.products==null) objCpy.products = [];

        objCpy.products.push(toAdd);

        this.setState({
            recipes: objCpy,
            recipeData: null,
            addProductOpen: false,
            addProduct: null
        });
    }

    render() {

        const steps = [
            {
                name: "Product ID",
                type: "number",
                min: 0,
                max: 65535,
                step: 1,
                decimal: false,
                value: this.state.recipeData==null ? "" : this.state.recipeData.id==null ? "" : this.state.recipeData.id,
                onChange: (val) => {
                    const cpy = {...this.state.recipeData};
                    cpy.id = parseInt(val);
                    this.setState({
                        recipeData: cpy
                    });
                },
                onValidate: (val) => this.state.recipes==null ?
                    null : this.state.recipes.products==null ?
                        null : this.state.recipes.products.find((obj) => obj.id===parseInt(val) && this.state.addProduct!==obj)==null ?
                            null : "Product with this ID already present!"
            },
            {
                name: "Product Name",
                type: "text",
                value: this.state.recipeData==null ? "" : this.state.recipeData.name==null ? "" : this.state.recipeData.name,
                onChange: (val) => {
                    const cpy = {...this.state.recipeData};
                    cpy.name = val;
                    this.setState({
                        recipeData: cpy
                    });
                },
                onValidate: (val) => val==null || val.length==0 ? "Name cannot be empty!" : null
            },
            {
                name: "Price",
                type: "number",
                min: 0.01,
                step: 0.01,
                decimal: true,
                value: this.state.recipeData==null ? "" : this.state.recipeData.price==null ? "" : this.state.recipeData.price,
                onChange: (val) => {
                    const cpy = {...this.state.recipeData};
                    cpy.price = parseFloat(val);
                    this.setState({
                        recipeData: cpy
                    });
                },
                onValidate: () => null
            },
            (
                <h3>Steps:</h3>
            )
        ];
        //Add all steps
        let stepCounter = 0;
        if(this.state.recipeData!=null && this.state.recipeData.recipe!=null) for(let step of this.state.recipeData.recipe) {
            const stepIndex = this.state.recipeData.recipe.indexOf(step);

            console.log("Step : "+(stepIndex+1)+" "+step.startOutputs.length);
            stepCounter++;
            steps.push(
                (
                    <div className="col-12 d-flex no-block align-items-center">
                        <h4>Step #{stepCounter}</h4>
                        {this.state.recipeData.recipe.length>1 ? (<div className="ml-auto text-right">
                            <a onClick={() => {
                                //Remove
                                if(stepIndex!==-1) {
                                    const objCpy = {...this.state.recipeData};
                                    objCpy.recipe.splice(stepIndex, 1);
                                    this.setState({
                                        recipeData: objCpy
                                    });
                                }
                            }} href="javascript:void(0);"><i className="fa fa-trash"/></a>
                        </div>) : ""}
                    </div>
                ),
                (
                    <h5>Start outputs</h5>
                ),
                (
                    <ReactTable
                        loading={false}
                        data={step==null || step.startOutputs==null ? [] : step.startOutputs}

                        columns={[
                            {
                                Header: "Output",
                                accessor: "pin",
                                sortable: true,
                                Cell: (row) => (
                                    <div style={{
                                        paddingLeft: "16px",
                                        paddingRight: "16px"
                                    }}>
                                        <ValidatedFormComponent
                                            type={"select"}
                                            onValidate={() => null}
                                            display_name_key="name"
                                            value_key="value"
                                            options={outputs}
                                            value={row.original.pin}
                                            onChange={(val) => {
                                                const objCpy = {...this.state.recipeData};
                                                const outIndex = objCpy.recipe[stepIndex].startOutputs.indexOf(row.original);
                                                if(outIndex!==-1) {
                                                    objCpy.recipe[stepIndex].startOutputs[outIndex].pin = isNaN(parseInt(val)) ? val : parseInt(val);
                                                }
                                                this.setState({
                                                    recipeData: objCpy
                                                });
                                            }}
                                        />
                                    </div>
                                )
                            },
                            {
                                Header: "Value",
                                accessor: "value",
                                sortable: true,
                                Cell: (row) => (
                                    <div style={{
                                        paddingLeft: "16px",
                                        paddingRight: "16px"
                                    }}>
                                        <ValidatedFormComponent
                                            type={"select"}
                                            onValidate={() => null}
                                            display_name_key="name"
                                            value_key="value"
                                            options={[
                                                {
                                                    name: "LOW",
                                                    value: 0
                                                },
                                                {
                                                    name: "HIGH",
                                                    value: 1
                                                }
                                            ]}
                                            value={row.original.value}
                                            onChange={(val) => {
                                                const objCpy = {...this.state.recipeData};
                                                const outIndex = objCpy.recipe[stepIndex].startOutputs.indexOf(row.original);
                                                if(outIndex!==-1) {
                                                    objCpy.recipe[stepIndex].startOutputs[outIndex].value = parseInt(val);
                                                }
                                                this.setState({
                                                    recipeData: objCpy
                                                });
                                            }}
                                        />
                                    </div>
                                )
                            },
                            {
                                Header: "",
                                maxWidth: 64,
                                Cell: (row) => {
                                    return (
                                        <div>
                                            {step.startOutputs!=null && step.startOutputs.length>1 ? (
                                                <a onClick={() => {
                                                    //Remove
                                                    const objCpy = {...this.state.recipeData};
                                                    const remIndex = objCpy.recipe[stepIndex].startOutputs.indexOf(row.original);
                                                    console.log("Remove index: "+remIndex);
                                                    if(remIndex!==-1 && stepIndex!==-1) {
                                                        objCpy.recipe[stepIndex].startOutputs.splice(remIndex, 1);
                                                        this.setState({
                                                            recipeData: objCpy
                                                        });
                                                    }
                                                }} href="javascript:void(0);"><i className="fa fa-trash"/></a>
                                            ) : ""}   {step.startOutputs!=null && step.startOutputs.indexOf(row.original)+1===step.startOutputs.length ? (
                                            <a onClick={() => {
                                                //Remove
                                                if(stepIndex!==-1) {
                                                    const objCpy = {...this.state.recipeData};
                                                    objCpy.recipe[stepIndex].startOutputs.push({
                                                        "pin" : "rel1",
                                                        "value" : 1
                                                    });
                                                    this.setState({
                                                        recipeData: objCpy
                                                    });
                                                }
                                            }} href="javascript:void(0);"><i className="fa fa-plus"/></a>
                                        ) : ""}
                                        </div>
                                    );
                                }
                            }
                        ]}
                        sortable={false}
                        filterable={false}
                        showPagination={false}
                        pageSize={step==null || step.startOutputs==null ? 0 : step.startOutputs.length}
                        className="-striped -highlight"
                    />
                ),
                (
                    <h5>Stop outputs</h5>
                ),
                (
                    <ReactTable
                        loading={false}
                        data={step==null || step.stopOutputs==null ? [] : step.stopOutputs}
                        columns={[
                            {
                                Header: "Output",
                                accessor: "pin",
                                sortable: true,
                                Cell: (row) => (
                                    <div style={{
                                        paddingLeft: "16px",
                                        paddingRight: "16px"
                                    }}>
                                        <ValidatedFormComponent
                                            type={"select"}
                                            onValidate={() => null}
                                            display_name_key="name"
                                            value_key="value"
                                            options={outputs}
                                            value={row.original.pin}
                                            onChange={(val) => {
                                                const objCpy = {...this.state.recipeData};
                                                const outIndex = objCpy.recipe[stepIndex].stopOutputs.indexOf(row.original);
                                                if(outIndex!==-1) {
                                                    objCpy.recipe[stepIndex].stopOutputs[outIndex].pin = isNaN(parseInt(val)) ? val : parseInt(val);
                                                }
                                                this.setState({
                                                    recipeData: objCpy
                                                });
                                            }}
                                        />
                                    </div>
                                )
                            },
                            {
                                Header: "Value",
                                accessor: "value",
                                sortable: true,
                                Cell: (row) => (
                                    <div style={{
                                        paddingLeft: "16px",
                                        paddingRight: "16px"
                                    }}>
                                        <ValidatedFormComponent
                                            type={"select"}
                                            onValidate={() => null}
                                            display_name_key="name"
                                            value_key="value"
                                            options={[
                                                {
                                                    name: "LOW",
                                                    value: 0
                                                },
                                                {
                                                    name: "HIGH",
                                                    value: 1
                                                }
                                            ]}
                                            value={row.original.value}
                                            onChange={(val) => {
                                                const objCpy = {...this.state.recipeData};
                                                const outIndex = objCpy.recipe[stepIndex].stopOutputs.indexOf(row.original);
                                                if(outIndex!==-1) {
                                                    objCpy.recipe[stepIndex].stopOutputs[outIndex].value = parseInt(val);
                                                }
                                                this.setState({
                                                    recipeData: objCpy
                                                });
                                            }}
                                        />
                                    </div>
                                )
                            },
                            {
                                Header: "",
                                maxWidth: 64,
                                Cell: (row) => {
                                    return (
                                        <div>
                                            {step.stopOutputs!=null && step.stopOutputs.length>1 ? (
                                                <a onClick={() => {
                                                    //Remove
                                                    const objCpy = {...this.state.recipeData};
                                                    const remIndex = objCpy.recipe[stepIndex].stopOutputs.indexOf(row.original);
                                                    console.log("Remove index: "+remIndex);
                                                    if(remIndex!==-1 && stepIndex!==-1) {
                                                        objCpy.recipe[stepIndex].stopOutputs.splice(remIndex, 1);
                                                        this.setState({
                                                            recipeData: objCpy
                                                        });
                                                    }
                                                }} href="javascript:void(0);"><i className="fa fa-trash"/></a>
                                            ) : ""}   {step.stopOutputs!=null && step.stopOutputs.indexOf(row.original)+1===step.stopOutputs.length ? (
                                            <a onClick={() => {
                                                //Remove
                                                if(stepIndex!==-1) {
                                                    const objCpy = {...this.state.recipeData};
                                                    objCpy.recipe[stepIndex].stopOutputs.push({
                                                        "pin" : "rel1",
                                                        "value" : 0
                                                    });
                                                    this.setState({
                                                        recipeData: objCpy
                                                    });
                                                }
                                            }} href="javascript:void(0);"><i className="fa fa-plus"/></a>
                                        ) : ""}
                                        </div>
                                    );
                                }
                            }
                        ]}
                        sortable={false}
                        filterable={false}
                        showPagination={false}
                        pageSize={step==null || step.stopOutputs==null ? 0 : step.stopOutputs.length}
                        className="-striped -highlight"
                    />
                ),
                (
                    <h5>Stop conditions</h5>
                ),
                (
                    <ReactTable
                        style={{
                            marginBottom: "32px"
                        }}
                        loading={false}
                        data={step==null || step.conditions==null ? [] : step.conditions}
                        columns={[
                            {
                                Header: "Condition",
                                accessor: "type",
                                sortable: true,
                                Cell: (row) => (
                                    <div style={{
                                        paddingLeft: "16px",
                                        paddingRight: "16px"
                                    }}>
                                        <ValidatedFormComponent
                                            type={"select"}
                                            onValidate={() => null}
                                            display_name_key="name"
                                            value_key="value"
                                            options={[
                                                {
                                                    name: "Timeout",
                                                    value: "timeout"
                                                },
                                                {
                                                    name: "Input interrupt",
                                                    value: "inputInterrupt"
                                                },
                                                {
                                                    name: "Current interrupt",
                                                    value: "currentInterrupt"
                                                }
                                            ]}
                                            value={row.original.type}
                                            onChange={(val) => {
                                                console.log("Setting type value to: "+val);
                                                const objCpy = {...this.state.recipeData};
                                                const outIndex = objCpy.recipe[stepIndex].conditions.indexOf(row.original);
                                                if(outIndex!==-1) {
                                                    objCpy.recipe[stepIndex].conditions[outIndex].type = val;
                                                    if(val==="timeout") {
                                                        objCpy.recipe[stepIndex].conditions[outIndex].timeout = 30;
                                                        objCpy.recipe[stepIndex].conditions[outIndex].result = "failed";
                                                    }
                                                    if(val==="inputInterrupt") {
                                                        objCpy.recipe[stepIndex].conditions[outIndex].pin = "in1";
                                                        objCpy.recipe[stepIndex].conditions[outIndex].count = 2;
                                                        objCpy.recipe[stepIndex].conditions[outIndex].result = "success";
                                                    }
                                                    if(val==="currentInterrupt") {
                                                        objCpy.recipe[stepIndex].conditions[outIndex].count = 2;
                                                        objCpy.recipe[stepIndex].conditions[outIndex].result = "success";
                                                    }
                                                }
                                                this.setState({
                                                    recipeData: objCpy
                                                });
                                            }}
                                        />
                                    </div>
                                )
                            },
                            {
                                Header: "Result",
                                accessor: "result",
                                sortable: true,
                                Cell: (row) => (
                                    <div style={{
                                        paddingLeft: "16px",
                                        paddingRight: "16px"
                                    }}>
                                        <ValidatedFormComponent
                                            type={"select"}
                                            onValidate={() => null}
                                            display_name_key="name"
                                            value_key="value"
                                            options={[
                                                {
                                                    name: "Success",
                                                    value: "success"
                                                },
                                                {
                                                    name: "Fail",
                                                    value: "failed"
                                                }
                                            ]}
                                            value={row.original.result}
                                            onChange={(val) => {
                                                const objCpy = {...this.state.recipeData};
                                                const outIndex = objCpy.recipe[stepIndex].conditions.indexOf(row.original);
                                                if(outIndex!==-1) {
                                                    objCpy.recipe[stepIndex].conditions[outIndex].result = val;
                                                }
                                                this.setState({
                                                    recipeData: objCpy
                                                });
                                            }}
                                        />
                                    </div>
                                )
                            },
                            {
                                Header: "Timeout",
                                accessor: "timeout",
                                sortable: true,
                                Cell: (row) => row.original.type==="timeout" ? (
                                    <div style={{
                                        paddingLeft: "16px",
                                        paddingRight: "16px"
                                    }}>
                                        <ValidatedFormComponent
                                            type={"number"}
                                            onValidate={() => null}
                                            min={1}
                                            step={1}
                                            value={row.original.timeout}
                                            onChange={(val) => {
                                                const objCpy = {...this.state.recipeData};
                                                const outIndex = objCpy.recipe[stepIndex].conditions.indexOf(row.original);
                                                if(outIndex!==-1) {
                                                    objCpy.recipe[stepIndex].conditions[outIndex].timeout = parseInt(val);
                                                }
                                                this.setState({
                                                    recipeData: objCpy
                                                });
                                            }}
                                        />
                                    </div>
                                ) : ""
                            },
                            {
                                Header: "Input",
                                accessor: "pin",
                                sortable: true,
                                Cell: (row) => row.original.type==="inputInterrupt" ? (
                                    <div style={{
                                        paddingLeft: "16px",
                                        paddingRight: "16px"
                                    }}>
                                        <ValidatedFormComponent
                                            type={"select"}
                                            onValidate={() => null}
                                            display_name_key="name"
                                            value_key="value"
                                            options={inputs}
                                            value={row.original.pin==null}
                                            onChange={(val) => {
                                                const objCpy = {...this.state.recipeData};
                                                const outIndex = objCpy.recipe[stepIndex].conditions.indexOf(row.original);
                                                if(outIndex!==-1) {
                                                    objCpy.recipe[stepIndex].conditions[outIndex].pin = isNaN(parseInt(val)) ? val : parseInt(val);
                                                }
                                                this.setState({
                                                    recipeData: objCpy
                                                });
                                            }}
                                        />
                                    </div>
                                ) : ""
                            },
                            {
                                Header: "Count",
                                accessor: "count",
                                sortable: true,
                                Cell: (row) => row.original.type==="inputInterrupt" || row.original.type==="currentInterrupt" ? (
                                    <div style={{
                                        paddingLeft: "16px",
                                        paddingRight: "16px"
                                    }}>
                                        <ValidatedFormComponent
                                            type={"number"}
                                            onValidate={() => null}
                                            min={1}
                                            step={1}
                                            value={row.original.count}
                                            onChange={(val) => {
                                                const objCpy = {...this.state.recipeData};
                                                const outIndex = objCpy.recipe[stepIndex].conditions.indexOf(row.original);
                                                if(outIndex!==-1) {
                                                    objCpy.recipe[stepIndex].conditions[outIndex].count = parseInt(val);
                                                }
                                                this.setState({
                                                    recipeData: objCpy
                                                });
                                            }}
                                        />
                                    </div>
                                ) : ""
                            },
                            {
                                Header: "",
                                maxWidth: 64,
                                Cell: (row) => {
                                    return (
                                        <div>
                                            {step.conditions!=null && step.conditions.length>1 ? (
                                                <a onClick={() => {
                                                    //Remove
                                                    const objCpy = {...this.state.recipeData};
                                                    const remIndex = objCpy.recipe[stepIndex].conditions.indexOf(row.original);
                                                    console.log("Remove index: "+remIndex);
                                                    if(remIndex!==-1 && stepIndex!==-1) {
                                                        objCpy.recipe[stepIndex].conditions.splice(remIndex, 1);
                                                        this.setState({
                                                            recipeData: objCpy
                                                        });
                                                    }
                                                }} href="javascript:void(0);"><i className="fa fa-trash"/></a>
                                            ) : ""}   {step.conditions!=null && step.conditions.indexOf(row.original)+1===step.conditions.length ? (
                                            <a onClick={() => {
                                                //Remove
                                                if(stepIndex!==-1) {
                                                    const objCpy = {...this.state.recipeData};
                                                    objCpy.recipe[stepIndex].conditions.push({
                                                        "type" : "timeout",
                                                        "result" : "failed",
                                                        "timeout": 30

                                                    });
                                                    this.setState({
                                                        recipeData: objCpy
                                                    });
                                                }
                                            }} href="javascript:void(0);"><i className="fa fa-plus"/></a>
                                        ) : ""}
                                        </div>
                                    );
                                }
                            }
                        ]}
                        sortable={false}
                        filterable={false}
                        showPagination={false}
                        pageSize={step==null || step.conditions==null ? 0 : step.conditions.length}
                        className="-striped -highlight"
                    />
                ));
        }

        steps.push((
            <Row style={{marginBottom: "16px"}}>
                <Col sm={5}/>
                <Col sm={2} componentClass={Button} className="btn-success"
                     bsStyle="success"
                     onClick={() => {
                         let objCpy = {...this.state.recipeData};
                         if(objCpy==null) {
                             objCpy = {};
                         }
                         if(objCpy.recipe==null) objCpy.recipe = [];

                         objCpy.recipe.push({
                             "startOutputs" : [
                                 {
                                     "pin" : "rel1",
                                     "value" : 1
                                 }
                             ],
                             "stopOutputs" : [
                                 {
                                     "pin" : "rel1",
                                     "value" : 0
                                 }
                             ],
                             "conditions" : [
                                 {
                                     "type":"timeout",
                                     "timeout":30,
                                     "result":"failed"
                                 }
                             ]
                         });

                         this.setState({
                             recipeData: objCpy
                         })
                     }}>
                    + New step
                </Col>
                <Col sm={5}/>
            </Row>
        ))

        return (
            <div className="page-wrapper">
                <div className="page-breadcrumb">
                    <div className="row">
                        <div className="col-12 d-flex no-block align-items-center">
                            <h3 className="page-title"><a href="#" onClick={this.close.bind(this)}><i className="mdi mdi-arrow-left font-24"></i></a> <i className="mdi mdi-receipt"></i> {this.props.recipeId==null ? "New recipes" : this.state.recipes!=null ? "Recipes - "+this.state.recipes.name : "Recipes"} </h3>
                            <div className="ml-auto text-right">
                                <button className="btn btn-success" onClick = {() => this.setState({
                                    saveOpened: true
                                })}>
                                    <i className="mdi mdi-floppy font-16"></i> Save
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="page-breadcrumb">
                    <div className="row">
                        <div className="col-12 d-flex no-block align-items-center">
                            <h4 className="page-title"><i className="fa fa-archive"></i> Products</h4>
                            <div className="ml-auto text-right">
                                <button className="btn btn-primary" style={{
                                    marginRight: "8px"
                                }} onClick = {() => this.setState({
                                    importOpen: true
                                })}>
                                    <i className="mdi mdi-import font-16"></i> Import
                                </button>
                                <button className="btn btn-primary" onClick = {() => this.setState({addProductOpen: true, addProduct: null, recipeData: {
                                        recipe: [{
                                            "startOutputs" : [
                                                {
                                                    "pin" : "rel1",
                                                    "value" : 1
                                                }
                                            ],
                                            "stopOutputs" : [
                                                {
                                                    "pin" : "rel1",
                                                    "value" : 0
                                                }
                                            ],
                                            "conditions" : [
                                                {
                                                    "type":"timeout",
                                                    "timeout":30,
                                                    "result":"failed"
                                                }
                                            ]
                                        }]
                                    }})}>
                                    <i className="mdi mdi-plus font-16"></i>Add Product
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <FormDialog onSubmit={(obj) => {
                                try {
                                    this.setState({
                                        importing: true,
                                        importErr: null
                                    });

                                    const arr = JSON.parse(obj["Import JSON"]);

                                    const objCpy = {...this.state.recipes};
                                    if(objCpy.products==null) objCpy.products = [];

                                    for(let element of arr) {
                                        console.log("Importing ",element);
                                        objCpy.products.push(element);
                                    }

                                    this.setState({
                                        recipes: objCpy,
                                        importOpen: false,
                                        importing: false,
                                        importErr: null
                                    });
                                } catch (e) {
                                    this.setState({
                                        importing: false,
                                        importErr: e.toString()
                                    });
                                }
                            }}
                            inputs={[
                                {
                                    type: "textarea",
                                    name: "Import JSON",
                                    onValidate: (val) => val.length===0 ? "JSON to import cannot be empty" : null
                                }
                            ]}
                            titleText={"Import"}
                            submitText={"Import"}
                            notification={this.state.importErr==null ? "" : (
                                <Alert bsStyle="danger">
                                    {this.state.importErr}
                                </Alert>
                            )}
                            loading={this.state.importing}
                            open={this.state.importOpen}
                            onClose={() => {
                                this.setState({
                                    importOpen: false
                                });
                            }}
                            width={800}
                />

                <FormDialog titleText={"Save"}
                            submitText={"Save"}
                            notification={this.state.savingErr==null ? "" : (
                                <Alert bsStyle="danger">
                                    {this.state.savingErr}
                                </Alert>
                            )}
                            inputs={[
                                {
                                    type: "text",
                                    name: "Name",
                                    onValidate: (val) => val.length==0 ? "Name cannot be empty!" : null,
                                    onChange: (val) => {
                                        const objCpy = {...this.state.recipes};
                                        objCpy.name = val;
                                        this.setState({
                                            recipes: objCpy
                                        });
                                    },
                                    value: this.state.recipes==null ? "" : this.state.recipes.name==null ? "" : this.state.recipes.name
                                },
                                {
                                    type: "textarea",
                                    name: "Description",
                                    onValidate: (val) => null,
                                    onChange: (val) => {
                                        const objCpy = {...this.state.recipes};
                                        objCpy.description = val;
                                        this.setState({
                                            recipes: objCpy
                                        });
                                    },
                                    value: this.state.recipes==null ? "" : this.state.recipes.description==null ? "" : this.state.recipes.description
                                }
                            ]}
                            open={this.state.saveOpened}
                            onClose={() => {
                                this.setState({
                                     saveOpened: false
                                });
                            }}
                            width={400}
                            onSubmit={(obj) => {
                                this.uploadRecipeData(obj["Name"], obj["Description"]);
                            }}
                            loading={this.state.savingLoading}/>

                <FormDialog titleText={this.state.addProduct==null ? "Add product" : "Edit product"}
                            submitText={this.state.addProduct==null ? "Add" : "Edit"}
                            notification={null}
                            inputs={steps}
                            open={this.state.addProductOpen}
                            onClose={() => {this.setState({
                                addProductOpen: false,
                                addProduct: null
                            })}}
                            width={800}
                            onSubmit={(obj) => {
                                const toAdd = {};
                                const objCpy = {...this.state.recipes};
                                toAdd.name = obj["Product Name"];
                                toAdd.id = parseInt(obj["Product ID"]);
                                toAdd.price = parseFloat(obj["Price"]);
                                toAdd.recipe = this.state.recipeData.recipe;
                                console.log("Submitted ",toAdd);
                                if(objCpy.products==null) objCpy.products = [];
                                if(this.state.addProduct!=null) {
                                    const prodIndex = objCpy.products.indexOf(this.state.addProduct);
                                    if(prodIndex!==-1) {
                                        objCpy.products.splice(prodIndex,1,toAdd);
                                    } else {
                                        objCpy.products.push(toAdd);
                                    }
                                } else {
                                    objCpy.products.push(toAdd);
                                }

                                this.setState({
                                    recipes: objCpy,
                                    recipeData: null,
                                    addProductOpen: false,
                                    addProduct: null
                                });
                            }}
                            loading={false}/>

                <FailedDialog open={this.state.loadingErr!=null} onClose={this.props.onClose}
                                title={"Unable to load"} text={this.state.loadingErr}/>


                <DeleteDialog access_code={this.props.access_code}
                              logout={this.props.logout}
                              url={REMOVE_RECIPE_ENDPOINT}
                              questionText="Do you really want to remove this recipe?"
                              questionTitle="Remove recipe"
                              successTitle="Remove success"
                              successText="Recipe has been successfully removed!"
                              failedTitle="Remove failed"
                              failedText="Error during recipe removal!"
                              loadingTitle="Removing recipe..."
                              sendParams={["recipeId"]}
                              onSuccess={() => this.tableRef.resetTable()}
                              dialogRef={ref => this.dialogRef = ref}/>

                <LoadingModal title="Loading..."
                            text="Loading recipes data..."
                            open={this.state.loading}/>

                <div className="container-fluid">
                    <ReactTable
                        loading={this.state.loading}
                        data={this.state.recipes==null ? [] : this.state.recipes.products==null ? [] : this.state.recipes.products}
                        defaultSorted={[
                            {
                                id: "id",
                                desc: false
                            }
                        ]}
                        getTdProps={(state, rowInfo, column, instance) => {
                            if(rowInfo!=null && column.Header!=='') return {
                                style: {
                                    cursor: 'pointer'
                                },
                                onClick: e => {
                                    console.log("Cell - onClick", rowInfo.original);
                                    this.setState({
                                        addProductOpen: true,
                                        addProduct: rowInfo.original,
                                        recipeData: {...rowInfo.original}
                                    });
                                }
                            };
                            return {};
                        }}
                        columns={[
                            {
                                Header: "Product ID",
                                accessor: "id",
                                filterable: true,
                                sortable: true,
                            },
                            {
                                Header: "Product name",
                                accessor: "name",
                                sortable: true,
                                filterable: true
                            },
                            {
                                Header: "Price",
                                accessor: "price",
                                Cell: (row) => (
                                    <Badge>{row.original.price.toFixed(2)} {this.props.currency}</Badge>
                                ),
                                sortable: true,
                                filterable: true
                            },
                            {
                                Header: "",
                                sortable: false,
                                filterable: false,
                                maxWidth: 40,
                                Cell: (row) => (
                                    <a href="javascript:void(0);" onClick={() => {
                                        const index = this.state.recipes.products.indexOf(row.original);
                                        if(index!==-1) {
                                            const cpy = {...this.state.recipes};
                                            cpy.products.splice(index, 1);
                                            this.setState({
                                                recipes: cpy
                                            });
                                        }
                                    }}><i className={"fa fa-trash"}></i></a>
                                )
                            }
                        ]}
                        filterable
                        defaultPageSize={10}
                        className="-striped -highlight"
                        pageSize={10}
                    />
                </div>
            </div>
        );
    }
}

export default RecipeScreen;